<template>
  <div>
    <div class="warehousingPage">
      <template v-if="state == 1">
        <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index"
            ><van-image width="100%" height="100%" :src="item"
          /></van-swipe-item>
        </van-swipe> -->

        <div class="title">
          <div class="txt">采购总数</div>
          <p>{{ pDetail.Quantity }}</p>
        </div>
        <div class="formDate">
          <div class="item">
            <div class="tit">入库数量</div>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.InventoryQuantity"
                placeholder="输入入库数量"
                maxlength="10"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">入库订单信息记录</div>
            <div class="input_box">
              <van-field
                v-model="formData.OrderInfoRecord"
                placeholder="输入入库订单信息"
                maxlength="50"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">入库收货物流类型记录</div>
            <div
              class="select_box flex-between margin_b"
              @click="handleClickOne(1)"
            >
              <van-field
                v-model="formData.LogisticsType"
                placeholder="选择记录入库收货物流类型"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="tit">入库收货物流单号记录</div>
            <div class="input_box">
              <van-field
                v-model="formData.LogisticsNumber"
                placeholder="入库收货物流单号记录"
                maxlength="50"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">备注信息记录</div>
            <div class="textarea_box">
              <van-field
                type="textarea"
                v-model="formData.Remark"
                placeholder="填写备注（200字以内）"
                maxlength="200"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">预计物流到货时间</div>
            <div class="input_box">
              <van-field
                v-model="formData.EstimatedArrivalTime"
                placeholder="预计物流到货时间"
                maxlength="50"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">入库商品批次记录</div>
            <div class="input_box">
              <van-field
                v-model="formData.ProductionBatch"
                placeholder="入库商品批次记录"
                maxlength="50"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">入库商品生产商记录</div>
            <!-- <div class="input_box">
              <van-field
                v-model="formData.Manufacturer"
                placeholder="入库商品生产商记录"
                maxlength="50"
              />
            </div> -->
            <div
              class="select_box flex-between margin_b"
              @click="handleClickOne(2)"
            >
              <van-field
                v-model="formData.Manufacturer"
                placeholder="入库商品生产商记录"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
        </div>
        <div class="return_group">
          <div class="primary-button" @click="handleSubmit">提交确认</div>
          <div class="primary-button return" @click="handleReturn">
            <i class="iconfont icon-yuyinjiantou"></i> 返回
          </div>
        </div>
      </template>
      <template v-if="state == 2">
        <div class="confirmationInfo">
          <div class="tit">采购信息确认</div>
          <div class="goods_desciption">
            <p class="txt1 fontSize-blueColor-xll">
              商品ID：{{ formData.cmid }}
            </p>
            <p class="txt2 fontSize-blueColor-xll">商品名称：</p>
            <p class="txt3">{{ detail.commodityname }}</p>
            <p class="txt3">{{ detail.commodityname_e }}</p>
            <p class="txt3">{{ detail.commodityname_y }}</p>
            <p class="txt3">{{ detail.commodityname_m }}</p>
            <p class="txt3">{{ detail.commodityname_t }}</p>
            <p class="txt1 fontSize-blueColor-xll">
              SKU采购编码：{{ detail.sku }}
            </p>
            <p class="txt1 fontSize-blueColor-xll">
              ISBN编码： {{ detail.ISBN }}
            </p>
            <p class="fontSize-blueColor-xll">
              品牌标签：{{ detail.commodityname_t }}
            </p>
          </div>
          <div class="goods_other_desciption">
            <div class="good_item">
              <h3>入库记录：</h3>
              <p>系统自动生成</p>
            </div>
            <div class="good_item">
              <h3>入库数量：</h3>
              <p>{{ formData.InventoryQuantity }}</p>
            </div>
            <div class="good_item">
              <h3>物流类型：</h3>
              <p>{{ formData.LogisticsType }}</p>
            </div>
            <div class="good_item">
              <h3>物流单号：</h3>
              <p>{{ formData.LogisticsNumber }}</p>
            </div>
            <div class="good_item">
              <h3>预计到货时间：</h3>
              <p>{{ formData.EstimatedArrivalTime }}</p>
            </div>
            <div class="good_item">
              <h3>入库商品批次记录：</h3>
              <p>{{ formData.ProductionBatch }}</p>
            </div>
            <div class="good_item">
              <h3>入库商品生产商记录：</h3>
              <p>{{ formData.Manufacturer }}</p>
            </div>
          </div>
          <div class="goods_mark">
            <h3>备注信息：</h3>
            <p>{{ formData.Remark }}</p>
          </div>
        </div>

        <div class="return_group">
          <div class="primary-button" @click="queryBtn">确认</div>
          <!-- <div class="default-button return" @click="state = 1">←返回</div> -->
          <div class="primary-button return" @click="state = 1">
            <i class="iconfont icon-yuyinjiantou"></i> 返回
          </div>
        </div>
      </template>
      <template v-if="state == 3">
        <div class="resultPage">
          <h1>入库记录保存成功</h1>
          <!-- <div class="default-button return" @click="handleReturn">←返回</div> -->
          <div class="primary-button return" @click="handleReturn">
            <i class="iconfont icon-yuyinjiantou"></i> 返回
          </div>
        </div>
      </template>
    </div>

    <van-popup v-model="isShow" position="bottom" :style="{ height: '40%' }">
      <template v-if="popupType == 1">
        <van-picker
          title="请选择物流类型"
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
      <template v-if="popupType == 2">
        <van-picker
          title="请选择生产商"
          show-toolbar
          :columns="supplierList"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
    </van-popup>
  </div>
</template>

<script>
import storage from "../../utils/storage";
import { mapState } from "vuex";
import {
  addPurchaseWare,
  getPurchaseDetail,
  getLogistics,
  getProducerList
} from "../../api/api";
export default {
  name: "pWareItem",
  data() {
    return {
      state: 1,
      qyid: 0,
      nowDate: "",
      bannerList: "",

      detail: "", // 商品详情

      isShow: false,
      columns: [],
      // 记录类型
      actname: "",
      actnameList: [
        {
          text: "增加",
          value: "add",
        },
        {
          text: "减少",
          value: "reduce",
        },
      ],

      popupType: 1,

      type: 1, // 1采购入库 2生产入库
      formData: {
        PurchaseID: "",
        InventoryQuantity: "", // 入库数量
        InventoryType: 1, //入库性质 = 1 按照采购计划到货入库 2 额外赠送 3 耗损补差
        OrderInfoRecord: "", // 入库订单信息记录
        LogisticsType: "", // 物流类型
        LogisticsNumber: "", // 物流单号
        EstimatedArrivalTime: "", // 预计物流到货时间
        Manufacturer: "", // 生产商
        ProductionBatch: "", // 生产批次
        Remark: "", // 备注信息
        openid: "", // 创建人openid
        InventoryStatus: 0, // 入库记录(计划)状态 = 0 待入库 1 已入库
        InventoryTime: "", // 入库时间
        Warehouse: "", // 入库位置-仓库 从接口259 260获取
        Shelf: "", // 入库位置-货架
        ShelfLayer: "", // 入库位置-货架层
        ShelfPosition: "", // 入库位置-货架上的货位
        ActualInventoryQuantity: "", // 实际入库数量
        DifferenceReason: "", // 数差原因
        InventoryCheckRemark: "", // 入库验收备注信息
        InventoryPhotos: "", // 拍照图片附件
        InventoryVerifierID: "", // 入库核验人
        InventoryVerifyTime: "", // 入库核验时间
      },

      supplierList: [],
      id: "", // 采购记录id
      pDetail: "", // 采购详情
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.id = this.$route.params.id;
    this.getInit();
  },
  methods: {
    async getInit() {
      let detailItem = storage.get("GOODDETAIL");
      this.detail = detailItem;
      let bannerList = [];
      bannerList.push(detailItem.banner);
      bannerList.push(detailItem.banner2);
      bannerList.push(detailItem.banner3);
      bannerList.push(detailItem.banner4);
      bannerList.push(detailItem.banner5);
      let filter = bannerList.filter((v) => v != "");
      this.bannerList = filter;

      // 获取详细
      let res = await getPurchaseDetail({ id: this.id });
      this.pDetail = res;
      this.formData.PurchaseID = res.ID;
      this.formData.openid = this.OPENID;
    },

    handleClickOne(type) {
      this.isShow = true;
      this.popupType = type
      if (type == 1) {
        this.getLogistics();
      } else if (type == 2) {
        this.getSupplier();
      }

    },
    // 获取物流类型
    getLogistics() {
      getLogistics().then((res) => {
        res.forEach((item) => {
          this.columns.push({
            value: item.evalue,
            text: item.evalue,
          });
        });
      });
    },

    // 获取生产商
    getSupplier() {
      let { qyid } = this;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getProducerList({ qyid, Page: 1, PageSize: 100 }).then((res) => {
        let newDate = [];
        res.forEach((v) => {
          newDate.push({
            value: v.id,
            text: v.labelname,
          });
        });
        this.supplierList = newDate;
        Toast.clear();
      });
    },

    // 确认弹窗
    onConfirm(e) {
      let { value } = e;
      this.formData.LogisticsType = value;
      this.isShow = false;
    },
    handleReturn() {
      history.go(-1);
    },

    handleSubmit() {
      let { formData } = this;
      if (formData.InventoryQuantity == "") {
        this.$toast("请输入入库数量");
        return;
      }
      if (formData.OrderInfoRecord == "") {
        this.$toast("请输入入库记录");
        return;
      }
      if (formData.LogisticsNumber == "") {
        this.$toast("请输入物流单号");
        return;
      }
      if (formData.LogisticsType == "") {
        this.$toast("请选择物流类型");
        return;
      }
      if (formData.EstimatedArrivalTime == "") {
        this.$toast("请输入到货时间");
        return;
      }
      if (formData.Manufacturer == "") {
        this.$toast("请输入生产商");
        return;
      }
      if (formData.ProductionBatch == "") {
        this.$toast("请输入生产批次");
        return;
      }
      this.state = 2;
    },
    queryBtn() {
      let { formData } = this;
      let params = formData;
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addPurchaseWare(params).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(data.message);
          }, 2000);
          setTimeout(() => {
            this.state = 3;
          }, 3500);
        } else {
          this.$toast.fail(data.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingPage {
  padding-bottom: 200px;
  .my-swipe {
    widows: 705px;
    height: 750px;
  }
  .title {
    text-align: center;
    font-size: 40px;
    padding-top: 80px;
    p {
      font-size: 32px;
      margin-top: 10px;
    }
  }
  .formDate {
    padding: 117px 75px 60px;
    .item {
      margin-bottom: 45px;
      .tit {
        font-size: 30px;
        color: #444444;
        margin-bottom: 28px;
        text-align: center;
      }
      .textarea_box {
        padding: 20px 57px;
      }
      /deep/ .van-cell {
        padding: 0;
        height: 100%;
      }
      /deep/ .van-field__body {
        height: 100%;
      }
      /deep/ .van-field__control {
        height: 100%;
      }
    }
  }
  .confirmationInfo {
    padding: 108px 64px 148px;
    .tit {
      font-size: 50px;
      color: #444444;
      text-align: center;
      margin-bottom: 100px;
    }
    .txt3 {
      font-size: 32px;
    }
  }
  .resultPage {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 35%;
  }
  .resultPage h1 {
    font-weight: 400;
    font-size: 50px;
    color: 50px;
    margin-bottom: 142px;
    text-align: center;
    white-space: nowrap;
  }
}
</style>